// Optionally Switch to Mapbox/Leaflet   https://www.algolia.com/doc/api-reference/widgets/geo-search/react/?language=component#full-example

import LocationRequiredOverlay from '@src/components/category/LocationRequiredOverlay';
import Loader from '@src/components/loader';
import Filters from '@src/components/search/Filters';
import * as filterActions from '@src/redux/actions/filters';
import dynamic from 'next/dynamic';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Link from 'next/link';
import { NextSeo } from 'next-seo';

const GoogleMap = dynamic(() => import('@src/components/search/GoogleMap'), {
	ssr: false,
});

const Locations = props => {
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		setTimeout(() => setLoading(false), 4000);
	}, []);

	const updateFilters = value => {
		props.setFilterValue(value);
	};

	let topCategories = props.categories.filter(category => {
		return category.includeInTopMenu;
	});

	if (loading) {
		return (
			<div className="page locations">
				<NextSeo
					title={`Locations | Mobile car and truck battery replacement services at every location`}
					description={`Roadside and onsite battery assistance services, combined with a nationwide support system for warranty and support.`}
					canonical={`https://1800battery.com/locations`}
				/>

				<div className="locations-header-alert">
					<div className="inner">
						<div className="container">
							<div className="content">
								<h1>1800Battery offers mobile car and truck battery replacement services <strong>at every location</strong>.</h1>
								<p>Roadside and onsite battery assistance services, combined with a nationwide support system for warranty and support.</p>
								<Link href={'/category/vehicle-batteries-car-or-truck'} as={'/category/vehicle-batteries-car-or-truck'}>
									<a className="btn book">
										Get Started Here
									</a>
								</Link>
							</div>
						</div>
					</div>
				</div>

				<div className="container mt-4">
					<Loader />
				</div>
			</div>
		);
	}

	return (
		<div className="page locations">
			<NextSeo
				title={`Locations | Mobile car and truck battery replacement services at every location`}
				description={`Roadside and onsite battery assistance services, combined with a nationwide support system for warranty and support.`}
				canonical={`https://1800battery.com/locations`}
			/>
			<div className="locations-header-alert">
				<div className="inner">
					<div className="container">
						<div className="content">
						<h1>1800Battery offers mobile car and truck battery replacement services <strong>at every location</strong>.</h1>
							<p>Roadside and onsite battery assistance services, combined with a nationwide support system for warranty and support.</p>
							<Link href={'/category/vehicle-batteries-car-or-truck'} as={'/category/vehicle-batteries-car-or-truck'}>
								<a className="btn book">
									Get Started Here
								</a>
							</Link>
						</div>
					</div>
				</div>
			</div>


			<div className="container" style={{ position: 'relative' }}>
				{!props.geolocation.latitude && <LocationRequiredOverlay />}
				<div className="header-with-filters mt-3">
					<Filters
						filters={props.filters}
						categories={topCategories}
						brands={props.brands}
						services={props.services}
						updateFilters={updateFilters}
					/>
				</div>
				<GoogleMap
					filters={props.filters}
					masterProvider={props.masterProvider}
					geolocation={props.geolocation}
				/>
			</div>
		</div>
	);
};

const mapDispatchToProps = dispatch => ({
	setFilterValue: payload => dispatch(filterActions.setFilterValue(payload)),
});

const mapStateToProps = state => ({
	geolocation: state.geolocation,
	categories: state.categories.allCategories,
	brands: state.brands.brands,
	services: state.services.services,
	filters: state.filters,
	masterProvider: state.masterProvider,
});

export default connect(mapStateToProps, mapDispatchToProps)(Locations);
